import {
  INVOICE_PIPELINE_REGISTRY,
  isSupportedInvoiceFileExtension,
  type InvoicePipelineName,
} from "encamp-shared/src/pipelines";
import { WasteInvoiceImportVendor } from "generated-graphql/graphql";

import { IMPORT_VENDOR_LABELS } from "../utils";

const PIPELINE_BY_VENDOR = {
  [WasteInvoiceImportVendor.CleanEarth]: "clean-earth-invoices",
  [WasteInvoiceImportVendor.Republic]: "republic-invoices",
} satisfies Record<WasteInvoiceImportVendor, InvoicePipelineName>;

export function invoiceFileExtension(fileName: string): string {
  return fileName.split(".").pop()?.toLowerCase() ?? "";
}

export function acceptedInvoiceExtensions(vendor: WasteInvoiceImportVendor): string[] {
  const pipelineName = PIPELINE_BY_VENDOR[vendor];
  return [...INVOICE_PIPELINE_REGISTRY[pipelineName].files[0].acceptedExtensions];
}

export function invoiceFileValidationMessage(
  fileName: string,
  vendor: WasteInvoiceImportVendor
): string | null {
  const pipelineName = PIPELINE_BY_VENDOR[vendor];
  if (isSupportedInvoiceFileExtension(pipelineName, fileName)) return null;
  const expected = acceptedInvoiceExtensions(vendor).join(" or ");
  return `${IMPORT_VENDOR_LABELS[vendor]} imports require a ${expected} workbook.`;
}
